import { RootScopeEvents } from '../../root-scope-types';
import { ErrorTrack } from '../error.track';
export default class PublisherErrorTrack extends ErrorTrack {
    start() {
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.PUBLISHER_ERROR, (e, { isFixed, errorName }) => {
            this.trackSegment({
                errorType: 'Media Stream Publisher Error',
                errorSubtype: errorName,
                isFixed,
            });
        });
    }
}
